<style>
	.tips-mask-t{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 50;
		background-color: rgba(0,0,0,.4);
		/*opacity: 0;*/
	}
	.tips-mask-t .tips-wrapper{
		position: absolute;
		width: 100%;
		margin-top: -90px;
		background-color: #eee;
		box-shadow: 0px 5px 10px rgba(0,0,0,.1)
	}
	.tips-mask-t .tips-wrapper .tips-font{
		margin: 0;
		text-align: center;
		border-bottom: solid 1px #f3f3f3;
		box-sizing: border-box;
		vertical-align: middle;
		background-color: #fff;
	}
	.tips-mask-t .tips-wrapper .tips-font p{
		height: auto;
		vertical-align: middle;
		font-size: .9em;
		margin: 0;
		padding: 10px;
		color: #aaa;
	}
	.tips-mask-t .tips-wrapper .tips-btns{
		margin: 0;
		padding: 0;
		text-align: center;
	}
	.tips-mask-t .tips-wrapper .tips-btns .tips-two-btn{
		display: block;
		font-size: 1.2em;
		width: 100%;
		padding: .6em 0;
		box-sizing: border-box;
		background-color: #fff;
	}
	.tips-mask-t .tips-wrapper .tips-btns .tips-one-btn{
		display: block;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		color:#25b8d4;
	}
	.tips-mask-t .tips-wrapper .tips-btns .tips-marbot{
		margin-bottom: .5em;
	}
	.tips-start{
		bottom: 0%;
		animation: tipsStart .3s;
		-webkit-animation: tipsStart .3s;
	}
	@keyframes tipsStart
	{
		from {bottom: -40%;}
		to {bottom: 0%;}
	}
	@-webkit-keyframes tipsStart
	{
		from {bottom: -40%;}
		to {bottom: 0%;}
	}
	.tips-end{
		bottom: -40%;
		animation: tipsEnd .3s;
		-webkit-animation: tipsEnd .3s;
	}
	@keyframes tipsEnd
	{
		from {bottom: 0%;}
		to {bottom: -40%;}
	}
	@-webkit-keyframes tipsEnd
	{
		from {bottom: 0%;}
		to {bottom: -40%;}
	}
</style>
<template>
	<div class="tips-mask-t" @click="onCancel" v-show="tipsMaks">
		<div class="tips-wrapper" :class="{'tips-start':topMove,'tips-end':!topMove}">
			<div class="tips-font" v-if="tipsFont"><p>{{tipsFont}}</p></div>
			<div class="tips-btns">
				<a class="tips-two-btn tips-marbot red-font" v-for="(btn, index) in btnFont" @click="onSelect(index)">{{btn}}</a>
				<a class="tips-two-btn" v-if="cancelFont" @click="onCancel">{{cancelFont}}</a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		value: {
			type: Boolean,
			required: true,
			default: false
		},
		cancelFont: {
			type: String,
			default: '取消'
		},
		tipsFont: {
			type: String,
			default: ''
		},
		btnFont: Array
	},
	data () {
		return {
			tipsShow: true,
			topMove: false,
			tipsMaks: false
		}
	},
	methods: {
		onSelect (index) {
			this.$emit('input', false)
			this.$emit('tipStatus', index)
		},
		onCancel () {
			this.topMove = false
			setTimeout(() => {
				this.tipsMaks = false
				this.$emit('input', false)
			}, 100)
		}
	},
	watch: {
		value: function (val, oldval) {
			this.tipsMaks = val
			this.topMove = val
		}
	}
}
</script>



// WEBPACK FOOTER //
// TipsSelect.vue?39d661d4